import React from 'react';
import { FormattedMessage } from 'react-intl';

import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

import AddIcon from '@mui/icons-material/Add';

const OptionAddNew = ({ onClick, style = {} }) => (
  <ListItemButton dense onClick={onClick} style={style}>
    <ListItemIcon sx={(theme) => ({ minWidth: 'auto', [theme.direction === 'rtl' ? 'pl' : 'pr']: 1 })}>
      <AddIcon />
    </ListItemIcon>
    <ListItemText sx={{ display: 'flex' }}>
      <FormattedMessage id="components.options.addNew" defaultMessage="Add New" />
      &nbsp;
      <Typography variant="inherit" component="span" sx={{ fontSize: 12 }} color="grey.600">
        <FormattedMessage id="components.options.pressEnter" defaultMessage="(press Enter)" />
      </Typography>
    </ListItemText>
  </ListItemButton>
);

export default OptionAddNew;
